<template>
  <div class="vid">
    <!-- <div class="vidCenter">
      <div
        class="four wow animated fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".5s"
      >
        品牌视频
      </div>
      <div
        class="yi wow animated fadeInUp"
        data-wow-duration="1.5s"
        data-wow-delay=".5s"
      ></div>
      <div
        class="video wow animated slideInUp"
        data-wow-duration="1s"
        data-wow-delay=".5s"
      >
        <video
          :src="vid.video"
          alt=""
          controls
          autoplay
          loop
          @click="SHOW()"
          poster="../../assets/about/矩形 3 拷贝 7.png"
          style="width= 100%; height=100%; object-fit: fill"
        />
        <img
          v-show="bofang"
          class="bofang"
          src="../../assets/about/bofang-3.png"
          alt=""
        />
      </div>
    </div> -->
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetHF } from "@/https/http";

export default {
  data() {
    return {
      vid: "",
      bofang: true,
    };
  },
  methods: {
    SHOW() {
      this.bofang = !this.bofang;
      var player = document.getElementById("player");
      if (player.play) {
        player.pause();
      } else {
        player.play();
      }
    },
  },
  created() {
    GetHF().then((res) => {
      this.vid = res.result;
    });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.vid {
  width: 100%;
  .vidCenter {
    width: 1440px;
    min-width: 1440px;
    margin: 0 auto;
    .four {
      width: 123px;
      height: 30px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      margin-left: 46.93%;
      margin-top: 148px;
    }
    .yi {
      width: 100px;
      height: 3px;
      background: linear-gradient(270deg, #fad126, #ff8229);
      border-radius: 0px;
      margin-left: 47.24%;
      margin-top: 19px;
    }
    .video {
      width: 1440px;
      height: 600px;
      margin-top: 60px;
      position: relative;
      video {
        width: 1440px;
        height: 600px;
      }
      img {
        width: 100%;
      }
      .bofang {
        width: 78px;
        height: 78px;
        position: absolute;
        top: 44%;
        left: 46%;
      }
    }
  }
}
</style>